var _path, _path2, _polygon, _polygon2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsdBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325,69.47l37.18-12.94a39.39,39.39,0,1,1-40.07-26.32Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.27,28.82l.85,30.52,28.11-10.87S351.86,32.64,330.27,28.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38,394.72V364.79a29.94,29.94,0,1,1-29.93,30.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.08,386.65l-29.94.68a31.62,31.62,0,0,1,8.48-21.56,30.8,30.8,0,0,1,21-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,411.94a18.57,18.57,0,0,1,11.54-1.4c2.1.34,4.28,1,5.71,2.54s1.69,4.35,0,5.7a5.5,5.5,0,0,1-3.59.91c-3.05,0-6.44-.57-8.88,1.26-1.39,1.05-2.31,2.79-4,3.31a3.94,3.94,0,0,1-4.33-1.93,6.74,6.74,0,0,1-.49-5A7.57,7.57,0,0,1,440,411.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.94,396.41c2.14,3.07,6.32,2,8.25.18s2.75-4.58,3.5-7.17c1.7-5.91,3.41-12.11,2.15-18.13a10.07,10.07,0,0,0-2.32-4.93,5.26,5.26,0,0,0-5-1.66c-2.11.56-3.41,2.62-4.36,4.58a43.16,43.16,0,0,0-4.27,18.55c0,3,.34,6.12,2,8.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,400.81a11.17,11.17,0,0,0,1.74-10.26,19.83,19.83,0,0,0-6.08-8.83,32.86,32.86,0,0,0-10.89-6.42,11.67,11.67,0,0,0-4.9-.83A5.15,5.15,0,0,0,401.8,377c-1.15,2.19-.05,4.84,1.14,7a83.48,83.48,0,0,0,7.15,10.9c2.15,2.76,4.6,5.49,7.87,6.73s6.66,1.11,8.39-1.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.79,442.67a6.65,6.65,0,0,0,.2-1.4c.09-1,.22-2.28.37-3.8a54.34,54.34,0,0,1,.85-5.58,43,43,0,0,1,2-6.58,24.24,24.24,0,0,1,3.36-5.95,12.61,12.61,0,0,1,4.25-3.54,11.74,11.74,0,0,1,3.58-1.11,6.62,6.62,0,0,0,1.39-.2,6.22,6.22,0,0,0-1.42,0,10.66,10.66,0,0,0-3.73,1,12.52,12.52,0,0,0-4.48,3.56,23.52,23.52,0,0,0-3.48,6.08,40.26,40.26,0,0,0-2,6.69,48.28,48.28,0,0,0-.74,5.64c-.12,1.62-.17,2.93-.19,3.83A6.49,6.49,0,0,0,431.79,442.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.05,439.74a2.27,2.27,0,0,0,0-.64v-1.85c0-1.61,0-3.93.08-6.8.14-5.73.63-11.9,1.59-20.6.9-8.18,2.11-17.71,3.39-23.9.28-1.4.55-2.67.81-3.78s.46-2.07.67-2.85.32-1.32.43-1.79a2.84,2.84,0,0,0,.11-.64,2.72,2.72,0,0,0-.22.6l-.54,1.78c-.24.76-.48,1.72-.76,2.82s-.6,2.37-.9,3.78A210.91,210.91,0,0,0,433.19,408c-1,8.72-1.39,16.66-1.43,22.41,0,2.87,0,5.2.1,6.8.05.75.09,1.36.12,1.85A3,3,0,0,0,432.05,439.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.09,424.43a11.43,11.43,0,0,0,0-1.93c-.07-1.24-.24-3-.59-5.23a69.38,69.38,0,0,0-1.7-7.63,64.72,64.72,0,0,0-3.19-9,48.16,48.16,0,0,0-9.36-14.57A22.19,22.19,0,0,0,415,384c-.33-.29-.63-.57-.94-.8l-.85-.59a13.27,13.27,0,0,0-1.63-1,57.66,57.66,0,0,1,5.33,4.76,50.59,50.59,0,0,1,9.13,14.52,72.38,72.38,0,0,1,3.21,8.94c.83,2.8,1.39,5.38,1.81,7.55s.63,4,.77,5.18A12.28,12.28,0,0,0,432.09,424.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.29 451.44 418.83 472.46 445.83 472.46 447.36 451.44 417.29 451.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.68,
    y: 443.15,
    width: 35.9,
    height: 8.28,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.68 471.65 414.68 473.95 416.37 473.95 449.99 473.95 449.99 471.65 414.68 471.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.02 477.99 416.37 473.95 448.71 473.95 446.78 477.99 418.02 477.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.86,458.31s0,.07-.12.19l-.41.54-1.57,2-.07.09-.07-.09-3.86-5.35H441l-3.8,5.39-.12.17-.14-.16-4.51-5.37h.26l-.25.31-4,5.06-.14.17-.12-.18-3.81-5.39h.22l-4.68,5.35-.09.09-.06-.11-1.47-2.46-.38-.66a1,1,0,0,1-.11-.23s.06.06.16.21l.41.63,1.54,2.42h-.14c1.2-1.41,2.76-3.25,4.61-5.41l.12-.14.1.15,3.84,5.36h-.26l4-5.07c.08-.11.17-.21.25-.31l.13-.16.13.15,4.5,5.38h-.25l3.84-5.36.11-.15.11.15c1.52,2.18,2.82,4,3.78,5.41h-.13l1.63-2,.44-.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.74,451.3c0,.09-6.77.17-15.11.17s-15.11-.08-15.11-.17,6.76-.17,15.11-.17S447.74,451.21,447.74,451.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.1,474.18c0,.09-7.35.17-16.42.17s-16.42-.08-16.42-.17,7.35-.17,16.42-.17S449.1,474.09,449.1,474.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.22,217.17a37.66,37.66,0,1,1,38.25,37.22A37.78,37.78,0,0,1,407.22,217.17Zm55.65-.9a18,18,0,1,0-17.71,18.38A18.06,18.06,0,0,0,462.87,216.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.22,217.17a37.78,37.78,0,0,1,37-38.43l.32,19.74a18.09,18.09,0,0,0,.58,36.17l.31,19.74A37.78,37.78,0,0,1,407.22,217.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.88,175.7a43,43,0,0,1,44.06,42.86l-23,.37c-.19-11.67-9.07-19-20.68-18.82Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.14,321.05,237.08,477.89h54.77l155-156.84S286.29,281.54,53.14,321.05Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,321.05,237.08,477.89h54.77l155-156.84S286.29,281.54,53.14,321.05Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,71.61v250s221.27-39.5,393.72,0v-250C312.4,94.34,181.23,95.76,53.14,71.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,71.61l7.34,1.26,9,1.56c3.57.61,7.71,1.39,12.39,2l15.65,2.34c1.43.21,2.9.45,4.4.64l4.61.58,9.78,1.22c3.39.41,6.9.9,10.54,1.29l11.28,1.14,12,1.2,12.72,1c4.36.31,8.82.73,13.4,1l14.09.76,7.28.39c2.46.12,4.94.16,7.45.25l15.37.47c20.91.33,43.48.43,67.45-.63,48-1.75,101.6-7.14,158.93-16.71l.28,0v.28c0,76.85,0,161.33,0,250v.32l-.32-.06h0c-18.28-4.13-36.58-7.3-54.74-9.8s-36.2-4.22-54-5.44c-8.91-.67-17.76-1-26.55-1.46l-13.13-.43c-4.36-.16-8.7-.17-13-.27-17.3-.24-34.31-.17-51,.33s-33,1.24-49,2.24-31.52,2.31-46.68,3.77-29.88,3.12-44.15,5-28.09,3.79-41.37,6.06l-.24,0v-.25c.13-152.83.21-248.31.21-250,0,1.67.08,97.15.2,250l-.24-.2c13.3-2.28,27.11-4.25,41.38-6.1s29-3.5,44.17-5,30.73-2.74,46.69-3.78,32.31-1.78,49-2.26,33.7-.58,51-.34c4.33.09,8.67.11,13,.26l13.13.44c8.79.42,17.65.78,26.56,1.45,17.82,1.22,35.88,2.9,54.05,5.43s36.49,5.68,54.79,9.82h0l-.32.25c0-88.65,0-173.13,0-250l.28.24c-57.35,9.56-111,14.92-159,16.64-24,1.05-46.56.93-67.47.58l-15.38-.48c-2.51-.09-5-.14-7.45-.26l-7.29-.4-14.09-.77c-4.58-.26-9-.68-13.4-1l-12.72-1-12-1.22-11.29-1.16c-3.64-.4-7.15-.89-10.53-1.3l-9.79-1.24-4.61-.59c-1.5-.2-3-.44-4.4-.65L81.85,76.62c-4.7-.66-8.8-1.45-12.36-2.07l-9-1.61Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,108.44c0-.06-73.95,13-166,13.16-92.1.56-166.22-12-166.17-12-.06-.36,74.05,12.08,166.18,11.53C350,121,424,108.08,424,108.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,125.72s-73.51,10.56-165.06,10.67c-91.57.46-165.25-9.69-165.21-9.67-.06-.32,73.63,9.69,165.21,9.23C349.46,135.82,423,125.4,423,125.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,143s-73.09,8.08-164.1,8.18c-91,.36-164.29-7.35-164.24-7.37-.07-.28,73.19,7.29,164.24,6.93C348.88,150.63,422,142.72,422,143Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.94,160.28c0,.06-72.66,5.61-163.13,5.69-90.5.26-163.33-5-163.28-5.07-.06-.24,72.76,4.89,163.28,4.63C348.3,165.44,421,160,420.94,160.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.94,177.56c0,.11-72.23,3.14-162.17,3.2S95.41,178.09,95.45,178s72.34,2.49,162.32,2.33S420,177.36,419.94,177.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.93,194.84c0,.15-71.8.67-161.2.71s-161.4-.33-161.36-.47,71.91.09,161.36,0S419,194.69,418.93,194.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.93,212.13c0,.18-71.37-1.81-160.24-1.79s-160.44,2-160.39,1.83,71.47-2.31,160.39-2.27S418,212,417.93,212.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.92,229.41c0,.23-70.94-4.29-159.27-4.28s-159.47,4.34-159.43,4.12c-.06-.07,71-4.71,159.43-4.56C346,224.67,417,229.34,416.92,229.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,246.69c0,.27-70.52-6.76-158.32-6.77-87.83-.24-158.5,6.68-158.46,6.42-.06,0,70.62-7.11,158.46-6.86C345.42,239.48,416,246.66,415.92,246.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.91,264c0,.31-70.08-9.24-157.35-9.27-87.29-.34-157.54,9-157.5,8.71-.06,0,70.19-9.5,157.5-9.15A1283.47,1283.47,0,0,1,414.91,264Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.9,281.26c0,.36-69.65-11.71-156.38-11.76-86.76-.44-156.57,11.35-156.53,11-.06,0,69.75-11.9,156.53-11.46A1024.14,1024.14,0,0,1,413.9,281.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.44,186.1l-1.23-.66a27.87,27.87,0,0,0-3.66-1.82,44.91,44.91,0,0,0-15.52-3.5,59.62,59.62,0,0,0-11.8.71,57.13,57.13,0,0,0-13.58,4c-1.18.49-2.3,1.13-3.48,1.69s-2.27,1.33-3.43,2-2.22,1.53-3.33,2.33a23.79,23.79,0,0,0-3,2.82c-3.6,4.15-6.23,9.19-8.7,14.46s-4.73,10.9-7.17,16.68A131.27,131.27,0,0,1,336,242.36a34.05,34.05,0,0,1-6.56,8,16.44,16.44,0,0,1-4.7,2.86c-.89.31-1.75.7-2.68.94a27.79,27.79,0,0,1-2.79.72,40.26,40.26,0,0,1-11.8.77A43.64,43.64,0,0,1,295.64,253a33.73,33.73,0,0,1-10.4-6.19,11.57,11.57,0,0,1-1.06-1l-1-1.09c-.59-.78-1.25-1.52-1.78-2.33a42.09,42.09,0,0,1-3-5c-3.52-6.89-5.75-14.31-7.94-21.82s-4.16-15.22-6.83-22.87a83.66,83.66,0,0,0-4.8-11.32,35.17,35.17,0,0,0-7.74-10.19,28.09,28.09,0,0,0-12.65-5.65l-.88-.18-.89-.12-1.78-.24c-1.2-.07-2.4-.21-3.59-.18a39,39,0,0,0-7.1.55,38.21,38.21,0,0,0-6.7,1.8c-.53.21-1,.44-1.56.66l-.78.33-.73.38-1.47.78-1.38.88a27.48,27.48,0,0,0-8.4,9c-4.11,6.94-5.58,14.65-7.83,22a55.74,55.74,0,0,1-4.3,10.65,30.92,30.92,0,0,1-7.36,9,27.42,27.42,0,0,1-10.65,5.5,21,21,0,0,1-11.9-.45,24.42,24.42,0,0,1-9.51-6.08,28.79,28.79,0,0,1-5.84-8.92c-2.74-6.43-3.58-13.1-4.36-19.4s-1.15-12.43-1.73-18.23a141.63,141.63,0,0,0-2.48-16.57,71.79,71.79,0,0,0-4.83-14.57,63.86,63.86,0,0,0-15.83-20.94,50.43,50.43,0,0,0-14.94-9.16c-.94-.34-1.76-.67-2.48-.91l-1.82-.5-1.48-.43,1.48.38,1.83.48c.72.23,1.55.55,2.5.89a50.23,50.23,0,0,1,15,9.12,64.16,64.16,0,0,1,16,21,71.42,71.42,0,0,1,4.88,14.61,140.52,140.52,0,0,1,2.53,16.6c.59,5.81,1,11.9,1.76,18.21s1.64,12.94,4.36,19.29a28.57,28.57,0,0,0,5.76,8.79,24.05,24.05,0,0,0,9.35,6,20.39,20.39,0,0,0,11.62.44,26.8,26.8,0,0,0,10.44-5.41,30.25,30.25,0,0,0,7.25-8.91,54.83,54.83,0,0,0,4.26-10.58c2.24-7.29,3.7-15,7.85-22.06a27.89,27.89,0,0,1,8.53-9.19l1.4-.89,1.5-.8.75-.39.79-.34,1.59-.67a38.93,38.93,0,0,1,14-2.38c1.22,0,2.44.11,3.65.18.61.07,1.21.16,1.82.24l.9.13.9.18a28.45,28.45,0,0,1,12.9,5.77,35.28,35.28,0,0,1,7.85,10.32,84.94,84.94,0,0,1,4.82,11.37c2.67,7.68,4.66,15.38,6.82,22.9s4.41,14.91,7.9,21.75a41.71,41.71,0,0,0,3,4.93c.53.81,1.18,1.54,1.76,2.3l1,1.07a11.24,11.24,0,0,0,1,1,33.43,33.43,0,0,0,10.23,6.09,42.94,42.94,0,0,0,11.71,2.65,40,40,0,0,0,11.66-.76c3.7-.84,7.34-2.06,10-4.41a33.9,33.9,0,0,0,6.49-7.93,130.68,130.68,0,0,0,8.56-17.45c2.45-5.76,4.72-11.38,7.2-16.67s5.14-10.33,8.79-14.52a24.57,24.57,0,0,1,3-2.86q1.68-1.21,3.36-2.34c1.17-.67,2.29-1.39,3.46-2s2.32-1.2,3.51-1.69a57.46,57.46,0,0,1,13.66-4,59.25,59.25,0,0,1,11.86-.67,44.5,44.5,0,0,1,15.54,3.6,27.18,27.18,0,0,1,3.64,1.86C419,185.85,419.44,186.1,419.44,186.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.08,257.52a4,4,0,0,1-4.19,3.85,4.14,4.14,0,0,1-4-4.17,4,4,0,0,1,4.19-3.86A4.12,4.12,0,0,1,311.08,257.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.73,164.61a3.93,3.93,0,0,1-4,3.92,4.09,4.09,0,0,1-4.07-4,3.92,3.92,0,0,1,4-3.92A4.08,4.08,0,0,1,234.73,164.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.48,177.58a5,5,0,0,1-4.87,4.59,4.13,4.13,0,0,1-4.4-4.29,5,5,0,0,1,4.86-4.58A4.07,4.07,0,0,1,401.48,177.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.89,225.8a4.26,4.26,0,1,1-4.39-4A4.2,4.2,0,0,1,173.89,225.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.74,108a12.06,12.06,0,0,1-3.5-.3,13.21,13.21,0,0,1-3.53-.82,11.65,11.65,0,0,1,3.5.3A13.21,13.21,0,0,1,80.74,108Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,125.38a11.2,11.2,0,0,1-3.48-.18,12.59,12.59,0,0,1-3.51-.72,12.05,12.05,0,0,1,3.48.2A13.48,13.48,0,0,1,81.73,125.38Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.72,142.8a11.64,11.64,0,0,1-3.46-.08,12.12,12.12,0,0,1-3.49-.61,11.83,11.83,0,0,1,3.46.09A12.53,12.53,0,0,1,82.72,142.8Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7,160.21a11.05,11.05,0,0,1-3.44,0,12.1,12.1,0,0,1-3.47-.49,11.05,11.05,0,0,1,3.44,0A12.52,12.52,0,0,1,83.7,160.21Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.69,177.63a11.5,11.5,0,0,1-3.42.13,11.8,11.8,0,0,1-3.45-.38,10.92,10.92,0,0,1,3.42-.14A11.6,11.6,0,0,1,84.69,177.63Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.68,195a11.69,11.69,0,0,1-3.4.25,11.35,11.35,0,0,1-3.43-.28,10.82,10.82,0,0,1,3.4-.25A11.4,11.4,0,0,1,85.68,195Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,212.45a11.5,11.5,0,0,1-3.38.36,11.09,11.09,0,0,1-3.4-.17,11.07,11.07,0,0,1,3.37-.36A11.48,11.48,0,0,1,86.66,212.45Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,229.86a11.34,11.34,0,0,1-3.36.46,10.82,10.82,0,0,1-3.39,0,10.86,10.86,0,0,1,3.36-.47A11.37,11.37,0,0,1,87.65,229.86Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.64,247.27a11.43,11.43,0,0,1-3.34.57,11,11,0,0,1-3.37.06,10.79,10.79,0,0,1,3.34-.58A11.21,11.21,0,0,1,88.64,247.27Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.62,264.68a11.26,11.26,0,0,1-3.31.68,10.92,10.92,0,0,1-3.35.17,10.74,10.74,0,0,1,3.32-.69A11,11,0,0,1,89.62,264.68Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.61,282.09a11.85,11.85,0,0,1-3.3.79,11.18,11.18,0,0,1-3.32.28,10.79,10.79,0,0,1,3.29-.8A10.64,10.64,0,0,1,90.61,282.09Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.52 118.64 223.78 118.64 223.78 138.71 228.61 138.71 228.61 146.9 237.28 138.71 289.52 138.71 289.52 118.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52,118.64s0,.11,0,.33,0,.58,0,1c0,.91,0,2.23,0,3.93,0,3.47.05,8.5.09,14.8v.16h-.16l-52.24.09.17-.07-8.66,8.19-.44.42v-8.79l.26.26h-5.09v-.26c0-7,0-13.73,0-20.07v-.25h.25l47.23.12,13.65.07,3.62,0,.93,0h.31l-.34,0h-1l-3.68,0-13.7.07-47.06.11.25-.25c0,6.34,0,13.08,0,20.07l-.26-.26h5.09v8.45l-.44-.19,8.67-8.19.07-.07h.11l52.24.09-.17.17c0-6.26.07-11.25.09-14.71,0-1.71,0-3,0-4,0-.44,0-.78,0-1A1.55,1.55,0,0,1,289.52,118.64Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.4,126.58c0,.14-11.07.26-24.72.26s-24.72-.12-24.72-.26,11.07-.26,24.72-.26S281.4,126.43,281.4,126.58Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.4,132c0,.14-11.07.26-24.72.26S232,132.13,232,132s11.07-.26,24.72-.26S281.4,131.85,281.4,132Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.93 146.38 362.93 166.45 367.76 166.45 376.43 166.45 428.67 166.45 428.67 146.38 362.93 146.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.93,146.38h.31l.93,0,3.66,0,13.72-.07,47.12-.12h.25v.26c0,6.37,0,13.11,0,20.05-.52.53-.16.15-.28.27H409.36l-17.73,0-28.7-.06h-.17v-.16c0-6.32.07-11.35.09-14.82,0-1.69,0-3,0-3.92l0-1a2.06,2.06,0,0,1,0-.33s0,.13,0,.36l0,1c0,.93,0,2.25,0,4,0,3.45.05,8.44.09,14.72l-.16-.17,28.7-.07h37c-.11.11.28-.26-.24.25V146.39l.26.25-46.94-.12L368,146.45l-3.71,0-1,0A1.3,1.3,0,0,1,362.93,146.38Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.55,154.32c0,.14-11.07.26-24.72.26s-24.72-.12-24.72-.26,11.07-.26,24.72-.26S420.55,154.18,420.55,154.32Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.55,159.73c0,.15-11.07.26-24.72.26s-24.72-.11-24.72-.26,11.07-.26,24.72-.26S420.55,159.59,420.55,159.73Z",
    style: {
      fill: "#D8571B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.29,478c0,.15-98.59.26-220.18.26s-220.2-.11-220.2-.26,98.57-.26,220.2-.26S470.29,477.85,470.29,478Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.75,424.06c.73-2.55,2.3-5,4.73-6.07s5.47-.48,8.06.45,5.14,2.19,7.9,2.35,5.85-1.15,6.67-3.78-.73-5.11-2.6-6.9a16.3,16.3,0,0,0-26.71,6.48",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.75,424.06c.73-2.55,2.3-5,4.73-6.07s5.47-.48,8.06.45,5.14,2.19,7.9,2.35,5.85-1.15,6.67-3.78-.73-5.11-2.6-6.9a16.3,16.3,0,0,0-26.71,6.48"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M127,435.17c-4-3.83-3.86-10.51-1.86-15.7s6.39-9.2,11.29-11.84a35.86,35.86,0,0,1,31.25-1.09,14.83,14.83,0,0,0-12,7.07c-2.21,3.68-2.69,8.15-4.51,12a18.92,18.92,0,0,1-24.2,9.53",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,412.13c-4.48-5.27-5.1-13.74-4.45-20.63s2.22-13.82,1.11-20.65c-.65-4.05-2.23-7.91-2.77-12s.2-8.66,3.34-11.29c3.62-3,9.32-2.32,13.09.5s6,7.26,7.56,11.69c3.53,9.73,4.84,20.52,2,30.47s-9.58,18.85-19.48,21.87",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.93,455.43a4,4,0,0,1,0-.6c0-.4,0-1,0-1.75.06-1.51.2-3.7.53-6.39a86,86,0,0,1,1.69-9.37,43.13,43.13,0,0,1,4.25-10.84,44.88,44.88,0,0,1,7-9.35,44.31,44.31,0,0,1,7.3-6.11c1.12-.77,2.19-1.36,3.12-1.91s1.79-.91,2.47-1.24l1.61-.68a5.31,5.31,0,0,1,.56-.22,2.8,2.8,0,0,1-.54.29l-1.57.74c-.67.35-1.49.78-2.43,1.29s-2,1.17-3.07,1.95a45.57,45.57,0,0,0-7.21,6.12,46.19,46.19,0,0,0-6.88,9.3c-4.09,7.2-5.2,14.76-6,20.06-.37,2.68-.55,4.86-.64,6.37,0,.73-.08,1.31-.1,1.74A4.59,4.59,0,0,1,122.93,455.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,391.4c-8.26,5-8.22,9.56-6.83,13.84s6.48,7.25,10.68,5.64c2.38-.92,4.1-3,5.56-5.07s2.85-4.31,4.91-5.81,5-2.07,7.12-.6",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.21,391.4c-8.26,5-8.22,9.56-6.83,13.84s6.48,7.25,10.68,5.64c2.38-.92,4.1-3,5.56-5.07s2.85-4.31,4.91-5.81,5-2.07,7.12-.6"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M78,396.89c2.16-3,7.5-3.87,10.88-2.39s5.85,4.44,8.07,7.38,4.38,6.06,7.45,8.11,7.35,2.78,10.4.7a8.91,8.91,0,0,0,3.52-6.12,20.41,20.41,0,0,0-.5-7.21c-.74-3.47-1.94-7.09-4.72-9.29-3.1-2.45-7.4-2.56-11.35-2.42-4.53.16-9.12.51-13.37,2.09s-8.58,5-10.38,9.15",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,448.83a.76.76,0,0,1,0-.19c0-.14,0-.31,0-.53,0-.5,0-1.18-.08-2.05,0-1.82-.13-4.39-.23-7.55s-.25-7-.49-11.19-.57-8.84-1.22-13.65a44.27,44.27,0,0,0-1.39-6.93,35.22,35.22,0,0,0-2.55-6.06,33.94,33.94,0,0,0-3.21-5,32.3,32.3,0,0,0-3.5-3.83,25.53,25.53,0,0,0-6.2-4.2c-.41-.19-.76-.37-1.07-.5l-.81-.31-.5-.2c-.11,0-.17-.07-.16-.08l.17.05.51.16.83.28c.32.12.68.29,1.09.47a24.5,24.5,0,0,1,6.32,4.14,32.59,32.59,0,0,1,3.56,3.83,34.47,34.47,0,0,1,3.27,5,35.52,35.52,0,0,1,2.6,6.11,44.36,44.36,0,0,1,1.41,7c.65,4.83,1,9.47,1.19,13.68s.33,8,.41,11.2.1,5.77.12,7.55v2.59A.76.76,0,0,1,116,448.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,452.56a23.54,23.54,0,0,1-.92-3.55,37,37,0,0,1-.4-10,65.88,65.88,0,0,1,3.12-14.49c1.68-5.33,4-11,5.93-17.15a74.61,74.61,0,0,0,3.5-17.72,127.66,127.66,0,0,0,.23-14.79c-.15-4.21-.39-7.62-.53-10-.07-1.16-.13-2.07-.17-2.71,0-.3,0-.53,0-.71a.73.73,0,0,1,0-.24,2.26,2.26,0,0,1,0,.24c0,.18,0,.41.07.7,0,.64.13,1.55.23,2.71.19,2.35.46,5.75.65,10a122.5,122.5,0,0,1-.15,14.83,80.11,80.11,0,0,1-1.14,8.69,78.31,78.31,0,0,1-2.35,9.11c-2,6.15-4.26,11.84-6,17.14A67.14,67.14,0,0,0,118,439.05a38.45,38.45,0,0,0,.28,9.93c.21,1.16.4,2.06.56,2.65l.17.69A1.52,1.52,0,0,1,119,452.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.54 456.25 100.7 456.34 99.8 448.87 139.53 448.77 139.54 456.25",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.87 455.48 109.78 477.89 130.88 477.84 135.37 455.4 104.87 455.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.54,456.25c0,.1-8.54.18-19.07.17s-19.07-.09-19.07-.19,8.54-.18,19.07-.18S139.54,456.14,139.54,456.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,467.33a16.13,16.13,0,0,0-3.42-1.95,12.18,12.18,0,0,0-4.16-.83,14.91,14.91,0,0,0-5.12.95c-1.76.61-3.42,1.31-5,1.7a12,12,0,0,1-4.35.14,8.8,8.8,0,0,1-2.79-.88,4.34,4.34,0,0,1-.68-.43q-.22-.16-.21-.18s.33.19,1,.48a9.68,9.68,0,0,0,2.77.75,12.28,12.28,0,0,0,4.24-.22c1.55-.39,3.2-1.1,5-1.71a14.63,14.63,0,0,1,5.23-.94,12,12,0,0,1,4.26.93,10.89,10.89,0,0,1,2.53,1.47,5.74,5.74,0,0,1,.61.52C132.85,467.25,132.91,467.32,132.9,467.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.61,468.83a17.15,17.15,0,0,0-3.29-1.93,11.1,11.1,0,0,0-4-.81,14.36,14.36,0,0,0-5,.9c-1.71.57-3.31,1.24-4.84,1.66a12.61,12.61,0,0,1-4.18.48,7,7,0,0,1-2.74-.73,4.69,4.69,0,0,1-.66-.41c-.14-.11-.21-.17-.2-.18s.32.19.92.46a7.61,7.61,0,0,0,2.69.6,13.1,13.1,0,0,0,4.08-.55c1.5-.43,3.09-1.1,4.82-1.68a14.36,14.36,0,0,1,5.07-.89,11,11,0,0,1,6.53,2.37,6.15,6.15,0,0,1,.58.51C132.56,468.75,132.62,468.82,132.61,468.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.29,465.84a18.53,18.53,0,0,0-3.52-2.06,12.82,12.82,0,0,0-4.27-1,13.75,13.75,0,0,0-5.27.94,45.71,45.71,0,0,1-5.21,1.71,13.26,13.26,0,0,1-4.49,0,9.87,9.87,0,0,1-2.89-.9,4.93,4.93,0,0,1-.7-.44c-.16-.11-.23-.17-.22-.18s.34.2,1,.49a11,11,0,0,0,2.87.77,13.3,13.3,0,0,0,4.38-.09,53.92,53.92,0,0,0,5.16-1.73,13.72,13.72,0,0,1,5.41-.93,13,13,0,0,1,7,2.67,7.45,7.45,0,0,1,.62.53A1.17,1.17,0,0,1,133.29,465.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.89,456.28c0,.1-8.74.2-19.52.23s-19.51,0-19.51-.14,8.73-.21,19.51-.23S139.89,456.17,139.89,456.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-176"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "286.01 445.79 287.38 477.98 304.76 477.59 303.46 445.34 286.01 445.79",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.91,476.58c.15,0-.12-7.06-.6-15.75s-1-15.72-1.12-15.71.12,7.05.6,15.74S295.77,476.58,295.91,476.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.29 475.76 304.67 475.32 304.76 477.59 287.38 477.98 287.29 475.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.35,467.28a2.61,2.61,0,0,0-.48-.68,11.9,11.9,0,0,0-1.63-1.58,11.34,11.34,0,0,0-2.89-1.75,9,9,0,0,0-4.09-.75,9.15,9.15,0,0,0-6.63,3.26,8,8,0,0,0-1.19,1.94,2.27,2.27,0,0,0-.24.8,19,19,0,0,1,1.71-2.5,9.24,9.24,0,0,1,6.38-3,10.72,10.72,0,0,1,6.73,2.27C303.52,466.43,304.28,467.35,304.35,467.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "303.83 454.52 303.97 458.06 286.55 458.38 286.43 455.71 303.83 454.52"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "286.43 458.8 286.69 461.66 304.12 461.66 304 458.8 286.43 458.8",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,447.28l1.54,19.55s-19.28,7.72-19.34,11.36L266.09,477l-1.15-30.56Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.93,464.76a1.57,1.57,0,0,1,1.16,1.74,1.5,1.5,0,0,1-1.71,1.16,1.65,1.65,0,0,1-1.22-1.84,1.56,1.56,0,0,1,1.92-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.09,477l-.09-2.44-36.8,1.92A2.91,2.91,0,0,0,228,478.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.16,467c0,.19,1,.23,1.9.79s1.47,1.33,1.63,1.25-.15-1.15-1.31-1.81S247.11,466.8,247.16,467Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.21,468.8c0,.19.79.47,1.46,1.23s.89,1.59,1.07,1.58.26-1.08-.59-2S243.21,468.62,243.21,468.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.14,473.71c.17,0,.39-.92-.13-1.92s-1.42-1.37-1.49-1.21.49.68.91,1.51S241,473.7,241.14,473.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.3,462.44c.09.17.94-.12,2-.1s1.89.33,2,.16-.73-.79-2-.81S247.21,462.3,247.3,462.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.44,458.25a3.48,3.48,0,0,0,1.92-.09,8.46,8.46,0,0,0,2-.7,11.14,11.14,0,0,0,1.08-.63,2.57,2.57,0,0,0,.56-.48.83.83,0,0,0,0-1,1.06,1.06,0,0,0-.84-.39,2.73,2.73,0,0,0-.71.13,6.59,6.59,0,0,0-1.18.46,6.87,6.87,0,0,0-1.72,1.24c-.85.86-1.12,1.57-1.06,1.6s.5-.54,1.37-1.26a7.86,7.86,0,0,1,1.67-1,7,7,0,0,1,1.09-.38c.4-.13.74-.14.85,0s0,.1,0,.22a1.89,1.89,0,0,1-.41.35,10.52,10.52,0,0,1-2.81,1.41A13.23,13.23,0,0,0,246.44,458.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.7,458.51a3.07,3.07,0,0,0,.42-1.87,6,6,0,0,0-.35-2.09,5.62,5.62,0,0,0-.54-1.14,1.57,1.57,0,0,0-1.26-.92.9.9,0,0,0-.78.57,3,3,0,0,0-.17.71,4.23,4.23,0,0,0,.06,1.29A4.42,4.42,0,0,0,245,457c.79,1,1.58,1.15,1.6,1.08s-.61-.43-1.23-1.35a4.42,4.42,0,0,1-.68-1.78,4.11,4.11,0,0,1,0-1.11c0-.41.18-.74.33-.71s.53.28.7.6a7,7,0,0,1,.52,1,6.82,6.82,0,0,1,.45,1.9C246.76,457.78,246.59,458.49,246.7,458.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "265.43 458.16 265.55 462.5 247.21 463.15 247.07 459.21 265.43 458.16"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M261.7,196.69l22.28-.28-2.48-19s1.52-.33,1.62-8.58.48-22.28.48-22.28h0a28.67,28.67,0,0,0-28.83,3.62l-1.22.94Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.13,161.29c-.14-.07-5.67-1.68-5.49,4s5.81,4.3,5.82,4.14S256.13,161.29,256.13,161.29Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.64,160.11c.14-.06,5.18-1.42,5,4.22s-5.81,4.3-5.82,4.14S282.64,160.11,282.64,160.11Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3,160.66c.85,4.72.68,7.21,1.46,10.37,1.24,5,3.72,8.83,8.22,11.33s10.6,2.45,14.47-1c2.68-2.36,4.58-5,5-8.57s.8-9.84.82-13.42c.05-6.44.48-12.6.48-12.6l-18.41-3.33-10.48,6.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.29,185.21a5.92,5.92,0,0,1-3.22.28,6,6,0,0,1-3.09-1c.06-.14,1.42.29,3.15.47S273.27,185.06,273.29,185.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.19,168.7c-.54-4.85-.89-10.39-1.64-15.5-.29-1.92-1-4.69-.8-6.62a16,16,0,0,1,1.21-5.67,8,8,0,0,1,12.42-2.5,6,6,0,0,1,10.9,2.52,4.15,4.15,0,0,1,6.85,4.16,4.06,4.06,0,0,1,2.74,6.21c-.86,1.31-2.39,2-3.33,3.29a4.7,4.7,0,0,0-.29,5.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.76,151.18a1.28,1.28,0,0,1-.2.53,3.82,3.82,0,0,1-1.07,1.21,3.9,3.9,0,0,1-2.4.75,4.06,4.06,0,0,1-2.95-1.38l.39-.11a3.86,3.86,0,0,1-2.46,2.83,4.4,4.4,0,0,1-4.15-.52,6.26,6.26,0,0,1-2.34-3.06l.45,0a5.2,5.2,0,0,1-4.17,2.28,4.77,4.77,0,0,1-3.51-1.43,4.87,4.87,0,0,1-1.27-2.16,2.09,2.09,0,0,1-.11-.89s.08.31.28.84a5.12,5.12,0,0,0,1.32,2,4.52,4.52,0,0,0,3.27,1.23,4.8,4.8,0,0,0,3.77-2.12l.27-.43.17.48a5.8,5.8,0,0,0,2.15,2.8,4,4,0,0,0,3.69.49,3.43,3.43,0,0,0,2.2-2.44l.08-.47.31.36a3.78,3.78,0,0,0,2.63,1.31,3.66,3.66,0,0,0,2.23-.61A5.15,5.15,0,0,0,280.76,151.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.73,148.94a5,5,0,0,0-.79-2.05,3.32,3.32,0,0,0-1.93-1.3,3.52,3.52,0,0,0-2.81.53l-.45.33.05-.56a4.34,4.34,0,0,0-.19-1.62,4.4,4.4,0,0,0-2.27-2.63,4.29,4.29,0,0,0-2.87-.26,6.13,6.13,0,0,0-2.39,1.35,1.74,1.74,0,0,1,.46-.62,4.36,4.36,0,0,1,1.84-1.08,4.6,4.6,0,0,1,3.16.17,4.86,4.86,0,0,1,2.56,2.91,4.63,4.63,0,0,1,.2,1.83l-.4-.23a3.89,3.89,0,0,1,3.21-.55,3.57,3.57,0,0,1,2.1,1.54,3.49,3.49,0,0,1,.57,1.63A1.16,1.16,0,0,1,280.73,148.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,149.11c-.07,0,0-.32,0-.78a3.65,3.65,0,0,0-.57-1.66,16.62,16.62,0,0,0-1.07-1.5c-.28-.29-.55-.09-.59-.12s0-.12.13-.22a.63.63,0,0,1,.69,0,3.9,3.9,0,0,1,.63.65,6.35,6.35,0,0,1,.65.87,3.11,3.11,0,0,1,.5,1.95C269.27,148.88,269,149.14,269,149.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.07,142c-.06,0,0-.44.34-1a2.86,2.86,0,0,1,.84-.88,2.16,2.16,0,0,1,1.5-.33,3.55,3.55,0,0,1,2.23,1.4c.41.52.6.88.55.93s-.35-.24-.82-.68a3.92,3.92,0,0,0-2-1.14,2.16,2.16,0,0,0-2,.91C258.32,141.68,258.14,142,258.07,142Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.93,166a9.3,9.3,0,0,1-1.94-3.6,9,9,0,0,1-.68-4c.15,0,.44,1.78,1.17,3.87S261.06,165.87,260.93,166Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4,167.3a6.88,6.88,0,0,1-1.36-2.56,6.74,6.74,0,0,1-.67-2.83,10.63,10.63,0,0,1,1.15,2.65A10.28,10.28,0,0,1,263.4,167.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,167.69a10.74,10.74,0,0,1-3.44,9.1,30.82,30.82,0,0,0,2.33-4.33A31.34,31.34,0,0,0,278.91,167.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.39,163.57a7.22,7.22,0,0,1,.36,4.47,7.12,7.12,0,0,1-1.92,4.05,24.22,24.22,0,0,0,1.41-4.14A25.65,25.65,0,0,0,281.39,163.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "274.72 323 280.34 377.19 284.38 458.8 305.91 458.8 306.46 296.76 303.61 285.42 245.87 290.01 232.06 380.63 243.13 460.39 266.76 460.39 261.22 384.55 274.72 323",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.72,323a33,33,0,0,1-4.19,4.14,32.15,32.15,0,0,1-4.55,3.73,65.29,65.29,0,0,1,8.74-7.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.66,321.91a61.1,61.1,0,0,1,.11-7,63.58,63.58,0,0,1,.4-6.94,35.57,35.57,0,0,1,.14,7A36.4,36.4,0,0,1,274.66,321.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.78,301.68a2.59,2.59,0,0,1,.35,0l1.06-.07,4.09-.2,14.6-.61h.24V301c0,4.56,0,9.71,0,15.16v.48l-.17.06-9.49,3.81-.09,0-.09,0-8.4-2.92-.13,0,0-.14c-.61-4.73-1.12-8.67-1.49-11.49-.16-1.32-.29-2.38-.39-3.16a9.24,9.24,0,0,1-.1-1.09,2.65,2.65,0,0,1,.07.31c0,.24.08.52.14.86.13.79.3,1.86.51,3.2.42,2.78,1,6.66,1.7,11.31l-.15-.18,8.42,2.86h-.17l9.48-3.82-.16.24v-.29c0-5.45,0-10.6,0-15.16l.25.24-14.44.36-4.15.08h-1.12A2,2,0,0,1,281.78,301.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.69,302a1.11,1.11,0,0,1,.31,0l1-.05,3.7-.11,13.31-.31h.25v.25c-.14,4.5-.31,9.69-.49,15.21V317l-.12.07-1.54,1-7.81,5.09-.13.09-.14-.08-8.8-5.36-.11-.07v-.13c.17-4.72.31-8.66.41-11.48.05-1.32.1-2.37.13-3.16s.07-1.09.08-1.07a1.15,1.15,0,0,1,0,.31v.85c0,.8,0,1.87,0,3.21,0,2.79-.1,6.68-.17,11.35l-.11-.19,8.83,5.29H259l7.8-5.11,1.54-1-.12.21c.2-5.52.39-10.71.55-15.2l.24.24-13.17.07h-4.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.84,326.5a15.11,15.11,0,0,1-2.92-.1c-1.79-.13-4.27-.37-7-.73s-5.18-.75-6.95-1.08a15.53,15.53,0,0,1-2.85-.65,16.13,16.13,0,0,1,2.9.28l7,.92,7,.89A15.76,15.76,0,0,1,299.84,326.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.34,386.9s-.08.32-.51.69a3.4,3.4,0,0,1-2.2.75,5.29,5.29,0,0,1-3.22-1.24,22.82,22.82,0,0,1-2.93-3,41.41,41.41,0,0,1-4.36-6.14,12.69,12.69,0,0,1-1.36-2.8,28.2,28.2,0,0,1,1.68,2.6,55.32,55.32,0,0,0,4.45,6,24,24,0,0,0,2.83,2.92,5,5,0,0,0,2.92,1.25,3.47,3.47,0,0,0,2.07-.54C299.14,387.13,299.31,386.88,299.34,386.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.81,388.81a1.46,1.46,0,0,1-.29.69,4.33,4.33,0,0,1-1.49,1.41,5.7,5.7,0,0,1-2.95.78,6.91,6.91,0,0,1-3.56-1.13,12.76,12.76,0,0,1-4.29-5.1,11.74,11.74,0,0,1-1.06-2.54,18.28,18.28,0,0,1,1.4,2.36,13.49,13.49,0,0,0,4.23,4.83,6.87,6.87,0,0,0,3.29,1.09,5.55,5.55,0,0,0,2.76-.62A6.08,6.08,0,0,0,256.81,388.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.18,380.63a5.38,5.38,0,0,1-1.77,1,14,14,0,0,1-9.72.4,5.13,5.13,0,0,1-1.85-.88,17.84,17.84,0,0,0,13.34-.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,192.74l1.36-4.69,24.49-1,2.37,4.19,22.25,7.69-4.91,50.82-1.55,20.9,1.56,5-2.25,4.48,1.38,8.25s-14.68,4.15-22.32,4.78-21.21-.93-21.21-.93l-13-2.26.86-12.19-1-2.28,1.09-2.3v-15L239.45,229l.37-30.25Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.82,198.73S201.35,240.49,201.34,249c0,6.36,15,30.79,23.86,36.35l7.37,6.05,8.53-9.67L234,276.36s.32-6.15-1.48-7.87-11.35-15.74-11.35-15.74a4.79,4.79,0,0,0,2.05-1.34c.59-.85,17-19.3,17-19.3l.48-15.58Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.21,253.71a7,7,0,0,1-1.76.53,23.52,23.52,0,0,0-4.19,1.19,28.87,28.87,0,0,0-3.67,2.35,6.4,6.4,0,0,1-1.56,1,6.43,6.43,0,0,1,1.34-1.25A19.61,19.61,0,0,1,215,255a17.15,17.15,0,0,1,4.34-1.07A6.09,6.09,0,0,1,221.21,253.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,276.36a13.08,13.08,0,0,1-3.14,5.54,19.2,19.2,0,0,1-3.35,3.05,5.5,5.5,0,0,1-1.63.93,54.4,54.4,0,0,0,4.59-4.32A39,39,0,0,0,234,276.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.74,279.94c-.07,0,.39-.57,1.37-.46a1.81,1.81,0,0,1,1.4.91,2.28,2.28,0,0,1,.23,1,1.29,1.29,0,0,1-.52,1,2,2,0,0,1-2,.28,1.74,1.74,0,0,1-.94-1.37c-.09-1,.47-1.43.49-1.37a2.76,2.76,0,0,0-.13,1.31,1.44,1.44,0,0,0,.79,1,1.53,1.53,0,0,0,1.49-.25.84.84,0,0,0,.34-.63,1.84,1.84,0,0,0-.15-.76,1.48,1.48,0,0,0-1-.77A2.79,2.79,0,0,0,234.74,279.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.25,267.66a2.33,2.33,0,0,1-.16-.51l-.37-1.47-1.24-5.44c-1-4.59-2.42-10.94-3.92-18s-2.83-13.39-3.77-18c-.45-2.25-.82-4.1-1.09-5.47-.11-.6-.19-1.09-.27-1.49a3.29,3.29,0,0,1-.06-.53,1.81,1.81,0,0,1,.17.51q.14.58.36,1.47c.31,1.36.73,3.19,1.25,5.43,1,4.59,2.42,10.94,3.92,18s2.83,13.39,3.77,18c.44,2.25.81,4.1,1.08,5.47.11.6.2,1.09.27,1.49A1.75,1.75,0,0,1,248.25,267.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.27,272.45a11.91,11.91,0,0,1-1.64.5c-1.06.3-2.62.67-4.55,1.07a105.87,105.87,0,0,1-30.69,1.82c-2-.18-3.55-.36-4.64-.53a11.05,11.05,0,0,1-1.69-.31,11.4,11.4,0,0,1,1.71.1c1.1.11,2.68.24,4.65.37a128,128,0,0,0,15.35.06A126.24,126.24,0,0,0,291,273.66c1.94-.36,3.5-.67,4.57-.91A9.6,9.6,0,0,1,297.27,272.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.08,282a3.17,3.17,0,0,1-.92.32c-.61.17-1.49.39-2.58.64-2.19.49-5.25,1-8.66,1.44s-6.51.53-8.76.55c-1.12,0-2,0-2.65,0a3.41,3.41,0,0,1-1-.1,34.08,34.08,0,0,1,3.62-.23c2.24-.11,5.32-.31,8.71-.7s6.44-.89,8.64-1.28A34.52,34.52,0,0,1,285.08,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.16,219.71a2.17,2.17,0,0,1,0,.56c0,.42-.06.95-.09,1.6,0,.35-.05.74-.08,1.15s-.12.88-.19,1.37a32.17,32.17,0,0,1-.6,3.3l-.46,1.9c-.16.66-.4,1.33-.62,2a44.46,44.46,0,0,1-1.64,4.38,52.32,52.32,0,0,1-5.35,9.27,52.87,52.87,0,0,1-7.28,7.85,45.75,45.75,0,0,1-3.7,2.86c-.61.41-1.17.84-1.76,1.19l-1.68,1c-1.05.66-2.1,1.1-3,1.55-.45.21-.85.42-1.24.58l-1.09.42-1.5.55a1.63,1.63,0,0,1-.53.16,2.49,2.49,0,0,1,.5-.25c.38-.18.87-.39,1.46-.65l1.05-.45c.39-.18.79-.4,1.22-.63a31.77,31.77,0,0,0,2.92-1.6l1.66-1c.57-.36,1.12-.8,1.72-1.21,1.21-.81,2.37-1.83,3.63-2.87a48.93,48.93,0,0,0,12.51-17,45.77,45.77,0,0,0,1.67-4.32c.22-.69.48-1.34.65-2s.32-1.27.48-1.87c.34-1.19.48-2.3.67-3.27.08-.48.18-.93.24-1.35s.08-.79.12-1.14q.11-1,.18-1.59A2.3,2.3,0,0,1,293.16,219.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,191.87a4.48,4.48,0,0,1-1,.42c-.68.24-1.67.53-2.92.85a48.61,48.61,0,0,1-9.92,1.37,48,48,0,0,1-10-.73c-1.26-.23-2.28-.46-3-.66a5.49,5.49,0,0,1-1.06-.34c0-.09,1.57.27,4.09.64a57.35,57.35,0,0,0,9.91.57,58.49,58.49,0,0,0,9.85-1.21C284.25,192.25,285.77,191.79,285.79,191.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M260.71,193.46a17.9,17.9,0,0,0,11.63,3.63,17.09,17.09,0,0,0,11.17-4.37,61.43,61.43,0,0,1-22.8.74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.66,290.44c7.07-3.24,15.57-.75,23.3-1.54,4.48-.46,8.81-1.86,13.24-2.66s9.18-.94,13.25,1a5.46,5.46,0,0,0,2.22.74c.78,0,1.63-.6,1.57-1.39a2,2,0,0,0-1-1.28,17,17,0,0,0-10.11-2.77,77.1,77.1,0,0,0-10.58,1.25,99.29,99.29,0,0,1-18.07,1,31.47,31.47,0,0,0-8.29.29c-2.71.62-5.35,2.25-6.4,4.83"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M308.21,198.94s35.42,39.9,35.4,48.4c0,6.35-14.11,30.84-22.35,36.43l-6.88,6.08-7.9-9.63,6.66-5.39s-.28-6.15,1.41-7.87,10.62-15.79,10.62-15.79a4.3,4.3,0,0,1-1.9-1.33c-.54-.84-18.76-19.22-18.76-19.22l.91-13.22Z",
    style: {
      fill: "#D8571B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.17,251.17a6,6,0,0,1,1.78.34,27.44,27.44,0,0,1,4.1,1.5,11.64,11.64,0,0,1,3.64,2.47c.79.86.86,1.65.8,1.64a7.72,7.72,0,0,0-1.07-1.39,14.21,14.21,0,0,0-3.59-2.25C327.78,252.08,325.12,251.34,325.17,251.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.38,274.88a45.51,45.51,0,0,0,3.11,5.09,43.26,43.26,0,0,0,4.15,4.29,12.55,12.55,0,0,1-4.56-4A13,13,0,0,1,313.38,274.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.87,279c0,.11-.5-.37-1.22-.19a1.66,1.66,0,0,0-.92.88,1.09,1.09,0,0,0,.15,1.36,1.23,1.23,0,0,0,1.38.25,1.49,1.49,0,0,0,.71-1,3.6,3.6,0,0,0-.1-1.28c0-.05.53.38.46,1.34a1.75,1.75,0,0,1-.84,1.38,1.69,1.69,0,0,1-2-.29,1.45,1.45,0,0,1-.47-1,1.89,1.89,0,0,1,.26-1,2,2,0,0,1,1.25-1,1.33,1.33,0,0,1,1.06.26C311.81,278.86,311.89,279,311.87,279Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.38,289.85s-3.44,4.58-6.62,2.17c0,0-4.45-.94-6.74-3.3s-2.65-3.8-4.27-3.91a48.88,48.88,0,0,1-6-1.39,1.42,1.42,0,0,1-.81-2.19,1.5,1.5,0,0,1,.69-.48c1.45-.49,7.9.12,7.9.12l1.88.11.33-2.76,2.19-1.76s1.39.85,1.32,2a2,2,0,0,1,2.24,1.76Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.57,291.39s3.67,4.56,7.1,2.14c0,0,4.79-1,7.26-3.33s2.87-3.82,4.6-3.93,6.72-.82,6.81-.78,1.36-2.82-.2-3.31-8.48.16-8.48.16l-2,.12-.34-2.77-.56-1.87s-3.28,1-3.22,2.13a2.19,2.19,0,0,0-2.41,1.77Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264.33,260.17c.05-3.46,2.64-6.38,5.49-8.35s6.11-3.35,8.69-5.66c5.09-4.55,6.64-11.78,10.08-17.68.54-.93,1.64-1.95,2.53-1.33.62.43.56,1.36.41,2.1a42.62,42.62,0,0,1-27.64,31.5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,208.11c.14,0-.88,14-2.28,31.29s-2.66,31.27-2.8,31.26.88-14,2.28-31.3S306.69,208.09,306.83,208.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M308.93,235a8.14,8.14,0,0,0-.07-4.1q-1.23-6.22-2.87-12.34c0,2.14-.51,5.32-.57,7.85,0,1.49-.28,4.84-.28,4.84Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M325,251.11a27.55,27.55,0,0,1,7.42-.4,6.32,6.32,0,0,1,1.83.36,2.44,2.44,0,0,1,1.35,1.23,2.57,2.57,0,0,1-.08,2,1.79,1.79,0,0,1-1.38,1.23c-.67,0-1.22-.5-1.72-1a8.63,8.63,0,0,0-2.91-1.71c-1.54-.54-3.32-.69-4.49-1.82"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M336.79,250.81a46.49,46.49,0,0,0-6.11-.43,46.5,46.5,0,0,0-6.06.92,16.1,16.1,0,0,1,12.17-.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.24,252.8a19.88,19.88,0,0,0-6.25-.68,5.4,5.4,0,0,0-2.62.44,1.68,1.68,0,0,0,.59,3.28,5.81,5.81,0,0,0,2-.33l5-1.45a2.16,2.16,0,0,0,.95-.46.73.73,0,0,0,.1-1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M240,229.26a29.37,29.37,0,0,0-3.09-10.4c-.18-.35-.43-.73-.81-.77-.6-.05-.89.72-.94,1.32a19.22,19.22,0,0,0,3.08,12.27c.28.42.76.88,1.21.64s.37-.68.34-1.09c-.1-1.38-.21-2.76-.31-4.14"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M265.49,193.84a2.59,2.59,0,0,1-.14-.85,12.09,12.09,0,0,1,.37-4.09,2.94,2.94,0,0,1,.28-.81c.06,0-.29,1.27-.43,2.86S265.55,193.83,265.49,193.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.23,192.41c-.07,0-.26-1.19-.69-2.62s-.9-2.54-.84-2.57a2.73,2.73,0,0,1,.38.7,15.35,15.35,0,0,1,1.09,3.7A3.12,3.12,0,0,1,281.23,192.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.34,275.9s0-.29-.1-.82-.16-1.38-.26-2.36c-.23-2.1-.55-5-1-8.66-.8-7.32-1.95-17.42-3.3-28.57s-2.68-21.23-3.66-28.52c-.49-3.61-.88-6.55-1.17-8.64-.13-1-.23-1.76-.31-2.35s-.09-.82-.09-.82.05.28.13.82.21,1.36.35,2.34l1.24,8.63c1,7.29,2.35,17.37,3.71,28.52s2.48,21.25,3.25,28.57c.37,3.62.66,6.57.88,8.67.09,1,.16,1.77.22,2.36S260.34,275.9,260.34,275.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.4,284.26s-.07-.1-.16-.29a7.75,7.75,0,0,1-.3-.85,9.77,9.77,0,0,1-.38-3,9.54,9.54,0,0,1,.53-2.93,7.19,7.19,0,0,1,.35-.84c.1-.19.16-.29.17-.28s-.16.44-.38,1.16a10.88,10.88,0,0,0-.15,5.81C264.26,283.81,264.43,284.25,264.4,284.26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.73,292.09a3.35,3.35,0,0,1-.57-.89,9.66,9.66,0,0,1-1-5,3.25,3.25,0,0,1,.18-1s0,.41,0,1.05a11.42,11.42,0,0,0,1,4.89C261.56,291.73,261.75,292.08,261.73,292.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,291.89a11.06,11.06,0,0,1-.35-1.35c-.19-.84-.47-2-.8-3.26s-.66-2.4-.91-3.23a8.92,8.92,0,0,1-.35-1.34,1.79,1.79,0,0,1,.15.34c.09.22.21.55.35,1,.27.81.62,1.95,1,3.22s.59,2.43.75,3.28c.08.42.14.77.17,1A1.22,1.22,0,0,1,285.19,291.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.69,273.46a3.56,3.56,0,0,1,.34,1,8.76,8.76,0,0,1,.18,2.59,9,9,0,0,1-.6,2.53,4.48,4.48,0,0,1-.5.95,13.24,13.24,0,0,0,.89-3.5,10.44,10.44,0,0,0-.11-2.54C291.78,273.86,291.66,273.47,291.69,273.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.3,242.89s0,.11,0,.32,0,.58-.05.92c-.05.91-.11,2-.18,3.38-.14,2.86-.25,6.81-.19,11.17s.28,8.31.49,11.16c.11,1.35.2,2.48.27,3.38,0,.35.05.65.08.92a1.93,1.93,0,0,1,0,.32,1.43,1.43,0,0,1-.06-.32l-.11-.91c-.09-.8-.21-2-.34-3.37-.25-2.85-.49-6.8-.55-11.17s.08-8.33.25-11.18c.09-1.43.18-2.59.25-3.38,0-.35.06-.65.09-.92A1.19,1.19,0,0,1,286.3,242.89Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.52,192.27c.06,0-.3,10.2-.8,22.78s-1,22.77-1,22.77.3-10.2.8-22.78S289.46,192.27,289.52,192.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.56,212.59c0,.06-15.16.87-33.86,1.81s-33.87,1.65-33.87,1.59,15.15-.86,33.86-1.8S306.55,212.54,306.56,212.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.26,250a1.3,1.3,0,0,1-.33.08l-1,.18c-.83.15-2,.35-3.53.57-3,.44-7.14,1-11.74,1.27s-8.78.4-11.8.38c-1.51,0-2.73,0-3.58-.07l-1,0-.34,0a2.3,2.3,0,0,1,.34,0h4.55c3,0,7.19-.12,11.79-.44s8.74-.8,11.73-1.21l3.54-.5,1-.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,242.19c0,.05-3.81.41-8.53.79s-8.54.65-8.55.6,3.82-.42,8.54-.8S303,242.13,303,242.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67,275.14s-3.08.92-8.16,2A147.65,147.65,0,0,1,275.43,280a149.29,149.29,0,0,1-20.28,0c-5.18-.37-8.36-.86-8.36-.86l.58,0,1.67.17c1.44.16,3.53.33,6.12.5a155.49,155.49,0,0,0,20.26-.06A153.7,153.7,0,0,0,295.48,277c2.54-.52,4.59-1,6-1.35l1.62-.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.94,227.39s-.05.06-.16.14l-.5.37c-.43.31-1.06.77-1.81,1.36a56.09,56.09,0,0,0-5.59,5A57.43,57.43,0,0,0,318,239.9c-.58.77-1,1.4-1.33,1.84l-.35.51-.14.17s0-.07.1-.19l.32-.53c.29-.46.72-1.1,1.28-1.88a48.17,48.17,0,0,1,4.82-5.74,50.93,50.93,0,0,1,5.65-4.94c.77-.57,1.4-1,1.86-1.31l.52-.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.14,250a3,3,0,0,1-.26-.32l-.72-.94-2.61-3.48c-2.22-2.94-5.32-7-8.85-11.33s-6.81-8.24-9.22-11l-2.85-3.29-.78-.9-.26-.32s.11.1.29.29l.81.87,2.9,3.25c2.44,2.76,5.74,6.62,9.27,11s6.62,8.41,8.81,11.37l2.56,3.52.68,1C333.07,249.89,333.14,250,333.14,250Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.58,251a3.76,3.76,0,0,1-2.39,4.09,5.51,5.51,0,0,0,1.74-1.73A5.67,5.67,0,0,0,336.58,251Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.59,276.1a1.34,1.34,0,0,1,.13-.25c.13-.2.27-.43.42-.68.44-.68,1-1.51,1.58-2.48,1.35-2.08,3.25-4.94,5.39-8.06s4.13-5.92,5.59-7.93l1.75-2.37.48-.63a2.08,2.08,0,0,1,.18-.22s0,.09-.14.24l-.46.66-1.69,2.4c-1.49,2.15-3.41,4.91-5.54,8s-4,5.87-5.43,8l-1.64,2.44-.45.66A1.57,1.57,0,0,1,313.59,276.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.42,281.29a31.33,31.33,0,0,1-2.88,2.44,34.64,34.64,0,0,1-3,2.28,35,35,0,0,1,2.88-2.44C316,282.27,317.39,281.25,317.42,281.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.22,272.87a4.66,4.66,0,0,1-.67-.26,13.89,13.89,0,0,1-1.77-.85,21.44,21.44,0,0,1-5.12-3.92,21.7,21.7,0,0,1-3.74-5.26,15.63,15.63,0,0,1-.79-1.8,3.14,3.14,0,0,1-.22-.68,6.12,6.12,0,0,1,.3.65c.17.43.46,1,.84,1.76a22.84,22.84,0,0,0,3.76,5.19,23.19,23.19,0,0,0,5,3.93c.72.41,1.31.72,1.73.91A4.13,4.13,0,0,1,331.22,272.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.58,217.52l-.35.39-1,1.1-3.8,4-12.6,13.24-3.6,3.76c-1.16,1.22-2.3,2.37-3.28,3.56-2,2.32-3.32,4.94-3.25,7.29a6.76,6.76,0,0,0,2,4.94,5.05,5.05,0,0,0,1.71,1l-.49-.16a4.4,4.4,0,0,1-1.28-.81,6.77,6.77,0,0,1-2.1-5c-.1-2.4,1.24-5.07,3.24-7.42,1-1.19,2.13-2.35,3.29-3.57l3.59-3.77,12.64-13.19c1.58-1.64,2.88-3,3.85-4l1-1.08C236.44,217.64,236.58,217.52,236.58,217.52Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.14,239.19,234,239c-.09-.19-.2-.39-.31-.61-.26-.53-.66-1.3-1.16-2.24A67.9,67.9,0,0,0,223,222.55c-.71-.79-1.3-1.42-1.72-1.84l-.47-.5a1.21,1.21,0,0,1-.16-.19l.19.16.5.47c.43.41,1,1,1.77,1.8a62.82,62.82,0,0,1,5.27,6.48,62.19,62.19,0,0,1,4.33,7.13c.49.95.86,1.73,1.1,2.28l.28.63A.77.77,0,0,1,234.14,239.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.78,251.4l-.21.06-.6.12c-.53.11-1.29.24-2.24.36a43.17,43.17,0,0,1-7.47.28,42.45,42.45,0,0,1-7.41-1c-.93-.22-1.68-.42-2.19-.58l-.59-.19a.6.6,0,0,1-.2-.08l.21,0,.6.15c.52.14,1.27.32,2.2.52a47.91,47.91,0,0,0,7.39,1,47,47,0,0,0,7.44-.22c.95-.1,1.72-.2,2.24-.29l.61-.08A.73.73,0,0,1,221.78,251.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.53,264a5.36,5.36,0,0,1-.59.38c-.39.22-.95.57-1.62,1a38,38,0,0,0-5,3.88,39.09,39.09,0,0,0-4.25,4.66c-.49.64-.88,1.17-1.13,1.54a3.86,3.86,0,0,1-.43.56,5.81,5.81,0,0,1,.36-.61c.24-.38.61-.92,1.09-1.58a33.53,33.53,0,0,1,4.22-4.72,33.87,33.87,0,0,1,5-3.85c.69-.43,1.26-.76,1.66-1A3.45,3.45,0,0,1,228.53,264Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.53,278.23s-3.64-5.23-8-11.76-7.9-11.86-7.85-11.89,3.64,5.24,8,11.77S232.58,278.2,232.53,278.23Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,288.07a30,30,0,0,1-2.8-2.06,27.33,27.33,0,0,1-2.67-2.22,31.65,31.65,0,0,1,2.8,2.06A27.33,27.33,0,0,1,234.71,288.07Z",
    style: {
      fill: "#fafafa"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsdBoard);
export default __webpack_public_path__ + "static/media/psd-board.84018ea534b9e189ea53a3bc6293301c.svg";
export { ForwardRef as ReactComponent };